import React, { useEffect, useState } from "react";
import AvatarUploader from "./AvatarUploader";
import avatarDonna from "../../assets/images/avatar_donna.png";
import avatarUomo from "../../assets/images/avatar_uomo.png";

function Background({ character, setCharacter }) {
  const [playerName, setPlayerName] = useState("");
  const [name, setName] = useState("");
  const [sex, setSex] = useState("Maschio");
  const [residence, setResidence] = useState("");
  const [bornage, setBornage] = useState(1900);
  const [avatar, setAvatar] = useState(null);

  useEffect(() => {
    if (character.characteristics) {
      setPlayerName(character.playerName);
      setName(character.characterInfo.name);
      setSex(character.characterInfo.sex);
      setResidence(character.characterInfo.residence);
      setBornage(character.characterInfo.bornage);
    }
    if (character.images) {
      setAvatar(character.images.avatar);
    }
  }, [character]);

  useEffect(() => {
    // Load default avatar if none exists and sex is set
    if (!avatar && sex) {
      loadDefaultAvatar(sex);
    }
  }, [sex, avatar]);

  const loadDefaultAvatar = async (gender) => {
    try {
      const defaultAvatar = gender === "Femmina" ? avatarDonna : avatarUomo;

      // Convert image to base64
      const response = await fetch(defaultAvatar);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatar(reader.result);
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Errore caricamento avatar default:", error);
    }
  };

  const handleSexChange = (newSex) => {
    setSex(newSex);
    // Ask user if they want to update the avatar
    if (
      avatar &&
      window.confirm("Vuoi caricare l'avatar di default per il nuovo sesso?")
    ) {
      loadDefaultAvatar(newSex);
    } else if (!avatar) {
      loadDefaultAvatar(newSex);
    }
  };

  const handleSaveStep = () => {
    setCharacter({
      ...character,
      playerName,
      characterInfo: {
        ...character.characterInfo,
        name,
        sex,
        residence,
        bornage,
      },
      images: { ...character.images, avatar },
    });
  };

  const saveButton = () => {
    const checkPlayerName = playerName === "";
    const checkName = name === "";
    if (checkName || checkPlayerName) {
      return (
        <>
          <button disabled>Salva e continua</button>
          {checkPlayerName && (
            <div className="error">Nome Giocatore obbligatorio</div>
          )}
          {checkName && (
            <div className="error">Nome Personaggio obbligatorio</div>
          )}
        </>
      );
    } else {
      return <button onClick={() => handleSaveStep()}>Salva e continua</button>;
    }
  };

  return (
    <div className="character-step-background">
      <h2>Background</h2>
      <div className="character-step-background-content">
        <div>
          <label>Nome Giocatore</label>
          <input
            type="text"
            value={playerName}
            className={playerName === "" ? "invalid" : ""}
            onChange={(e) => setPlayerName(e.target.value)}
          />
        </div>
        <div>
          <label>Nome Personaggio</label>
          <input
            type="text"
            value={name}
            className={name === "" ? "invalid" : ""}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div>
          <label>Sesso</label>
          <select value={sex} onChange={(e) => handleSexChange(e.target.value)}>
            <option value="Maschio">Maschio</option>
            <option value="Femmina">Femmina</option>
          </select>
        </div>
        <div>
          <label>Residenza</label>
          <input
            type="text"
            value={residence}
            onChange={(e) => setResidence(e.target.value)}
          />
        </div>
        <div>
          <label>Anno di nascita</label>
          <input
            type="number"
            value={bornage}
            onChange={(e) => setBornage(e.target.value)}
          />
        </div>
      </div>
      <AvatarUploader avatar={avatar} setAvatar={setAvatar} />
      {saveButton()}
    </div>
  );
}

export default Background;
